module.exports = __webpack_public_path__ + "media/images/home/search-db50a343ab72ef4103764c9102775e44.svg";